<script setup>
const props = defineProps({
  headline: String,
  subtitle: String,
  subtitle_2: String,
  selectedProduct: Object
});


const products = inject('products')
const cart = useCart();

function addToCart(product) {
  cart.add({...product, title: "Organic Cajamarca Microlot"})
  cart.checkout("", true)
}

defineBuilderComponent({
    friendlyName: 'Content_Section_5',
    ignored: true
})
</script>

<template>

  <section id="the-products">
    <div class="relative block overflow-hidden aspect-auto">
      <nuxt-img
          width="1046"
          height="611"
          format="webp"
          sizes="sm:697px md:100vw lg:100vw xl:1046px"
          src="/assets/images/indonesia-8.jpg"
          alt="Nature Behind Rainbow Coffee"
          class="absolute object-cover w-full h-full brightness-75"
          loading="lazy"
      />
      <div class="relative z-20 max-w-screen-lg pt-0 mx-auto lg:pt-32">
        <div class="relative mt-12 text-center md-max:mt-0">
          <h2 class="lg:mt-2 font-extrabold p-4 text-whitem z-[1] relative h2 text-white">

            Click the "Order Now" button to secure your very own taste of Rony Lavan's exceptional coffee, and become a part of the extraordinary story unfolding in the heart of the Peruvian highlands.
           </h2>

        </div>
      </div>
      <div class="pb-12 mt-16 bg-white lg:mt-20 lg:pb-20">
        <div class="relative z-0">
          <div class="absolute inset-0 h-5/6 lg:h-2/3"></div>
          <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div class="relative lg:grid lg:grid-cols-7">
              <div
                  class="max-w-md mx-auto lg:mx-0 lg:max-w-none lg:col-start-1 lg:col-end-3 lg:row-start-2 lg:row-end-3"
              >
                <div
                    class="flex flex-col h-full overflow-hidden rounded-lg shadow-lg lg:rounded-none lg:rounded-l-lg"
                >
                  <div class="flex flex-col flex-1">
                    <div class="px-6 py-10 bg-white">
                      <div class="aspect-auto">
                        <h3
                            class="mb-4 text-2xl font-medium text-center text-gray-900"
                            id="tier-hobby"
                        >
                          1 Bag
                        </h3>
                        <nuxt-img
                            width="299"
                            height="320"
                            class="object-contain w-auto mx-auto h-80"
                            src="/assets/images/product-1-cajamarka.png"
                            alt="1 Bag"
                            format="webp"
                            sizes="sm:320px md:320px lg:260px xl:299px"
                            loading="lazy"
                        />
                        <div class="flex items-center justify-center mt-4">
                        <span
                            class="flex items-start px-3 text-6xl tracking-tight text-gray-900 font-ww-medium"
                        ><span class="mt-2 mr-2 text-4xl font-medium">
                            <!-- -->$<!-- --> </span
                        ><span class="font-extrabold"> 51.00 </span></span
                        >
                        </div>
                      </div>
                    </div>
                    <div
                        class="flex flex-col justify-between flex-1 p-6 border-t-2 border-gray-100 bg-gray-50 sm:p-10 lg:p-6 xl:p-10"
                    >
                      <ul
                          role="list"
                          class="flex flex-col items-center justify-center mx-auto space-y-4"
                      >
                        <li class="flex items-start">
                          <div class="flex-shrink-0">
                            <svg
                                class="flex-shrink-0 w-6 h-6 text-green-500"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                aria-hidden="true"
                            >
                              <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M5 13l4 4L19 7"
                              ></path>
                            </svg>
                          </div>
                          <p class="ml-3 text-lg font-medium text-black">
                            Free Shipping
                          </p>
                        </li>
                      </ul>
                      <div class="mt-8">
                        <div class="rounded-lg shadow-md">
                          <button
                              @click="addToCart(products[0])"
                              class="block w-full text-center rounded-lg hover:bg-blueProduct hover:text-white border-2 border-[#507c93] bg-white px-6 py-3 text-base font-semibold text-[#507c93]"
                              aria-describedby="tier-hobby"
                          >Add to Cart</button
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                  class="max-w-lg mx-auto mt-10 lg:mt-0 lg:max-w-none lg:mx-0 lg:col-start-3 lg:col-end-6 lg:row-start-1 lg:row-end-4"
              >
                <div class="relative z-10 rounded-lg shadow-xl">
                  <div
                      class="pointer-events-none absolute inset-0 rounded-lg border-2 border-[#507c93]"
                      aria-hidden="true"
                  ></div>
                  <div class="absolute inset-x-0 top-0 transform translate-y-px">
                    <div class="flex justify-center transform -translate-y-1/2">
                    <span
                        class="inline-flex rounded-full bg-[#507c93] px-4 py-1 text-sm font-semibold tracking-wider uppercase text-white"
                    >
                      <!-- -->Most popular<!-- -->
                    </span>
                    </div>
                  </div>
                  <div class="px-6 pt-12 pb-10 bg-white rounded-t-lg">
                    <div>
                      <h3
                          class="mb-4 text-3xl font-semibold text-center text-gray-900 sm:-mx-6"
                          id="tier-growth"
                      >
                        6 Bags
                      </h3>
                      <nuxt-img
                          width="320"
                          height="320"
                          class="object-contain w-auto mx-auto h-80"
                          src="/assets/images/product-6-cajamarka.png"
                          alt=" 6 Bags"
                          format="webp"
                          sizes="sm:320px md:320px lg:320px xl:320px"
                          loading="lazy"
                      />
                      <div class="flex items-center justify-center mt-4">
                      <span
                          class="flex items-start px-3 text-6xl tracking-tight text-gray-900 sm:text-6xl font-ww-medium"
                      ><span class="mt-2 mr-2 text-4xl font-medium">
                          <!-- -->$<!-- --> </span
                      ><span class="font-extrabold"> 239.70 </span></span
                      >
                      </div>
                    </div>
                  </div>
                  <div
                      class="px-6 pt-10 pb-8 border-t-2 border-gray-100 rounded-b-lg bg-gray-50 sm:px-10 sm:py-10"
                  >
                    <ul
                        role="list"
                        class="flex flex-col items-center justify-center mx-auto space-y-4"
                    >
                      <li class="flex items-start">
                        <div class="flex-shrink-0">
                          <svg
                              class="flex-shrink-0 w-6 h-6 text-green-500"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              aria-hidden="true"
                          >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                        </div>
                        <p class="ml-3 text-lg font-medium text-black">
                          $39.95 Per bag
                        </p>
                      </li>
                      <li class="flex items-start">
                        <div class="flex-shrink-0">
                          <svg
                              class="flex-shrink-0 w-6 h-6 text-green-500"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              aria-hidden="true"
                          >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                        </div>
                        <p class="ml-3 text-lg font-medium text-black">
                          Free Shipping
                        </p>
                      </li>
                    </ul>
                    <div class="mt-10">
                      <div class="rounded-lg shadow-md">

                        <button
                            @click="addToCart(products[2])"
                            class="block w-full text-center rounded-lg border-2 border-blueProduct bg-blueProduct px-6 py-4 text-xl leading-6 font-bold text-white hover:bg-[#507c93]"
                            aria-describedby="tier-growth"
                        >
                          <!-- -->Add to Cart<!-- -->
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                  class="max-w-md mx-auto mt-10 lg:m-0 lg:max-w-none lg:col-start-6 lg:col-end-8 lg:row-start-2 lg:row-end-3"
              >
                <div
                    class="flex flex-col h-full overflow-hidden rounded-lg shadow-lg lg:rounded-none lg:rounded-r-lg"
                >
                  <div class="flex flex-col flex-1">
                    <div class="px-6 py-10 bg-white">
                      <div>
                        <h3
                            class="mb-4 text-2xl font-medium text-center text-gray-900"
                            id="tier-scale"
                        >
                          3 Bags
                        </h3>
                        <nuxt-img
                            width="280"
                            height="320"
                            class="object-contain w-auto mx-auto h-80"
                            src="/assets/images/product-3-cajamarka.png"
                            alt="3 bags"
                            format="webp"
                            sizes="sm:320px md:320px lg:240px xl:280px"
                            loading="lazy"
                        />
                        <div class="flex items-center justify-center mt-4">
                        <span
                            class="flex items-start px-3 text-6xl tracking-tight text-gray-900 font-ww-medium"
                        ><span class="mt-2 mr-2 text-4xl font-medium">
                            <!-- -->$<!-- --> </span
                        ><span class="font-extrabold"> 137.85 </span></span
                        >
                        </div>
                      </div>
                    </div>
                    <div
                        class="flex flex-col justify-between flex-1 p-6 border-t-2 border-gray-100 bg-gray-50 sm:p-10 lg:p-6 xl:p-10"
                    >
                      <ul
                          role="list"
                          class="flex flex-col items-center justify-center mx-auto space-y-4"
                      >
                        <li class="flex items-start">
                          <div class="flex-shrink-0">
                            <svg
                                class="flex-shrink-0 w-6 h-6 text-green-500"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                aria-hidden="true"
                            >
                              <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M5 13l4 4L19 7"
                              ></path>
                            </svg>
                          </div>
                          <p class="ml-3 text-lg font-medium text-black">
                            $45.95 Per bag
                          </p>
                        </li>
                        <li class="flex items-start">
                          <div class="flex-shrink-0">
                            <svg
                                class="flex-shrink-0 w-6 h-6 text-green-500"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                aria-hidden="true"
                            >
                              <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M5 13l4 4L19 7"
                              ></path>
                            </svg>
                          </div>
                          <p class="ml-3 text-lg font-medium text-black">
                            Free Shipping
                          </p>
                        </li>
                      </ul>
                      <div class="mt-8">
                        <div class="rounded-lg shadow-md">
                          <button
                              @click="addToCart(products[1])"
                              class="block w-full text-center hover:bg-blueProduct hover:text-white rounded-lg border-2 border-[#507c93] bg-white px-6 py-3 text-base font-semibold text-[#507c93]"
                              aria-describedby="tier-scale"
                          >
                            <!-- -->Add to Cart<!-- -->
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>